import { inject, Injectable } from '@angular/core';

import { ScreenModel } from '@module-definition/screen/common';
import { HttpService } from '@shared/services/http.service';

@Injectable({ providedIn: 'root' })
export class ScreenService {
  private http = inject(HttpService);

  get(id: number) {
    const params = this.http.buildHttpParams({ id });
    return this.http.get<ScreenModel>('_api/Screen/Get', {
      httpOptions: { params },
      useLoader: false,
    });
  }
}
